export default "__VITE_ASSET__MooLiWxG__"